'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { debounce } from 'underscore';
import { NavMarker } from 'react-rhumb';
import { getUserId } from 'DesignData/selectors/auth';
import { fetch, update } from 'DesignData/actions/codemirror/Options';
import CodeComponent from 'DesignManagerIde/components/settings/Code';
import Settings from 'react-codemirror/model/Settings';

function mapStateToProps(state) {
  return {
    userId: getUserId(state)
  };
}

const mapDispatchToProps = {
  fetch,
  update
};
/**
 * @class Container for Code settings forms.
 */

class Code extends Component {
  constructor(props) {
    super(props);

    this.onSettingsChange = () => {
      this.setState(this.getStateFromSettings());
    };

    this.saveSettings = debounce(() => {
      this.props.update(this.settings);
    }, 500);

    this.reset = () => {
      Settings.reset(this.settings);
      this.saveSettings();
    };

    this.update = settings => {
      Object.assign(this.settings, settings);
      this.saveSettings();
    };

    this.settings = Settings.getByUserId(props.userId);
    this.settings.on(this.onSettingsChange);
    this.state = this.getStateFromSettings();
  }

  componentDidMount() {
    this.props.fetch();
  }

  componentWillUnmount() {
    this.settings.off(this.onSettingsChange);
  }

  getStateFromSettings() {
    return {
      isDefaultSettings: Settings.isDefaultFields(this.settings),
      settings: Object.assign({}, this.settings)
    };
  }

  /*
   * Render
   */
  render() {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "CODE_SETTINGS",
      children: /*#__PURE__*/_jsx(CodeComponent, {
        update: this.update,
        reset: this.reset,
        settings: this.state.settings,
        isDefaultSettings: this.state.isDefaultSettings,
        registerToolbarContent: this.props.registerToolbarContent
      })
    });
  }

}

Code.propTypes = {
  registerToolbarContent: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  fetch: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(Code);